import React, { useEffect, useState } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';

// import { isAuthenticated } from './services/auth';

import Login from './pages/login/Login';

import App from './pages/app';

import { isSignedIn } from './auth/index';

import { ConfigProvider } from './auth/context';

import Cadastro from './pages/cadastro/Cadastro'
import RedefinirSenha from './pages/redefinir/RedefinirSenha'
const PrivateRoute = ({ component: Component, signed, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      signed ?
       (

        <Component {...props} />
      ) : (

        <Redirect
          to={{ pathname: '/login', state: { from: props.location } }}
        />
      )
    }
  />
);

const Routes = () => {
  const [userData, setUserData] = useState(undefined);
  const [signed, setSigned] = useState(false);
  const [signLoaded, setSignLoaded] = useState(false);

  useEffect(() => {
    validarSessao();
  }, []);

  const validarSessao = (atualizarUsuarioContext) => {

    const sessionData = isSignedIn();

    setSigned(sessionData.signed);
    setUserData(sessionData.userData);
    setSignLoaded(true);

    if (atualizarUsuarioContext) atualizarUsuarioContext(sessionData.userData);
    // isSignedIn()
    //   .then((res) => {
    //     // setSigned(res.signed);
    //     // setUserData(res.userData);
    //     // setSignLoaded(true);
    //   })
    //   .catch((err) => alert(err));
  };

  if (!signLoaded) return null;

  return (
    <ConfigProvider userData={signed ? userData : {}}>
      <Router>
        <Switch>
          {/* <Route exact path="/login" component={Login} /> */}

          <Route
            path="/login"
            exact={true}
            render={(props) => (
              <Login {...props} validarSessao={validarSessao} />
            )}
          />
          <Route exact path={`/cadastro`} component={Cadastro} />
          <Route exact path={`/redefinir-senha`} component={RedefinirSenha} />

          <Redirect exact from={`/`} to={`/app`} />
          <PrivateRoute signed={signed} path="/app" component={App} />
          <Route path="*" component={() => <h1>Page not found</h1>} />

        </Switch>
      </Router>
    </ConfigProvider>
  );
};

export default Routes;
